import { useQuery, type UseQueryOptions } from '@tanstack/vue-query';

interface GameResponse {
  games: any[];
  success: boolean;
}

export function useTeamGames(
  teamId: MaybeRef<string | number>,
  params?: any,
  options?: Omit<UseQueryOptions<GameResponse, Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    queryKey: ['team-games', teamId, params] as const,
    queryFn: () => {
      const currentTeamId = toValue(teamId);
      if (!currentTeamId) return { games: [], success: false };

      const queryStringFromParams = Object.entries(toValue(params))
        .filter(([_, value]) => value !== null) // filter out null values
        .map(([key, value]) => `${key}=${value}`) // map to query string
        .join('&'); // join with &
      return $fetch<GameResponse>(
        `/api/games/team/${currentTeamId}?${queryStringFromParams}`,
        {
          method: 'GET',
        }
      );
    },
    ...options,
  });
}
